import React from "react";
import { Moon, SunMedium } from "lucide-react";

export type Theme = "light" | "dark";

interface ThemeToggleProps {
  theme: Theme;
  setTheme: (t: Theme) => void;
}

const ThemeToggle: React.FC<ThemeToggleProps> = ({ theme, setTheme }) => {
  const toggle = () => setTheme(theme === "dark" ? "light" : "dark");

  return (
    <button
      type="button"
      onClick={toggle}
      className="inline-flex items-center gap-2 rounded-full border border-slate-700/70 bg-slate-900/70 px-3 py-1 text-[11px] font-medium text-slate-300 hover:border-emerald-400 hover:text-emerald-200 dark:bg-slate-100/80 dark:text-slate-800 dark:border-slate-300/80 dark:hover:border-emerald-500"
      aria-label="Toggle color mode"
    >
      {theme === "dark" ? (
        <>
          <SunMedium className="h-3.5 w-3.5" />
          <span>Light mode</span>
        </>
      ) : (
        <>
          <Moon className="h-3.5 w-3.5" />
          <span>Dark mode</span>
        </>
      )}
    </button>
  );
};

export default ThemeToggle;
